<template>
  <div class="bc-report-risk">
    <type-container title="体检事实">
      <pagination-table
        v-for="table in typeTables"
        :key="table.key"
        :title="table.source.title"
        :table-data="table.source.entities"
        :table-props="table.source.props"
        :total="table.source.total"
        :loading="table.source.loading"
        :page-index="table.source.pageIndex"
        :page-size="table.source.pageSize"
        :is-question="table.source.isQuestion"
        :is-page-hand="table.source.pageHand"
        :show-total="table.source.showTotal"
        @pageChanged="tablePageChanged($event, table)"
      />
      <div
        v-if="showEmpty"
        class="no-data-tip"
      >暂无相关信息</div>
    </type-container>
    <!-- 校验是否显示echarts -->
    <report-analysis
      type="risk"
      kind="analysis"
      :law-suit-count="lawSuitCount"
    />
    <report-analysis
      type="risk"
      kind="suggestion"
    />
  </div>
</template>

<script>
import TypeContainer from '@/components/report/ReportTypeContainer'
import PaginationTable from '@/components/table/PaginationTable'
import ReportAnalysis from './ReportAnalysis'
import lawExamProps from '@/service/law-exam/props'
import mixin from '@/mixins/lawExamReport'
export default {
  name: 'BcReportRisk',
  components: { TypeContainer, PaginationTable, ReportAnalysis },
  mixins: [ mixin ],
  data () {
    return {
      showEmpty: false,
      lawSuitCount: {},
      openNotice: { ...lawExamProps.openNotice },
      lawSuit: { ...lawExamProps.lawSuit },
      execute: { ...lawExamProps.execute },
      dishonest: { ...lawExamProps.dishonest },
      judicial: { ...lawExamProps.judicial }
    }
  },
  computed: {
    // 被执行信息 execute
    // 法律诉讼 lawSuit
    // 开庭公告 openNotice
    // 失信人信息 dishonest
    // 司法协助 judicial
    typeTables () {
      return [
        { key: 'openNotice', source: this.openNotice },
        { key: 'lawSuit', source: this.lawSuit },
        { key: 'execute', source: this.execute },
        { key: 'dishonest', source: this.dishonest },
        { key: 'judicial', source: this.judicial }
      ]
    }
  },
  watch: {
    typeTables: {
      deep: true,
      handler () {
        let hasDatas = this.typeTables.filter(table => {
          let source = table.source
          return source.loadFinished && source.total === 0
        })
        this.showEmpty = hasDatas.length === 5
      }
    }
  },
  mounted () {
    this.lawSuitCount = this.lawSuit
  }
}
</script>

<style lang="stylus">
.bc-report-risk
  .no-data-tip
    color #9b9b9b
    text-align center
</style>
